import { divIcon, DivIcon, LatLng, LeafletEvent } from 'leaflet';
import { ReactElement, ReactNode, useMemo } from 'react';
import { renderToString } from 'react-dom/server';
import { Marker } from 'react-leaflet';

import './leaflet-icon-pin.styles.scss';

export interface ILeafletIconPinProps {
	position: LatLng;
	icon: ReactElement;
	children?: ReactNode;
	className?: string;
	draggable?: boolean;
	onDragEnd?: (latLng: LatLng) => void;
	onClick?: () => void;
}

export function LeafletIconPin(props: ILeafletIconPinProps): ReactElement {
	const {
		position,
		icon,
		children,
		className,
		draggable,
		onDragEnd,
		onClick
	} = props;

	const markerIcon: DivIcon = useMemo<DivIcon>(() => {
		return divIcon({
			className: `leaflet-icon-pin ${className}`,
			html: renderToString(icon)
		});
	}, [icon, className]);

	function onMarkerDragEnd(event: LeafletEvent): void {
		if (draggable && onDragEnd) onDragEnd((event as any).target._latlng);
	}

	function onMarkerClick(): void {
		if (onClick) onClick();
	}

	return (
		<Marker
			position={position}
			icon={markerIcon}
			draggable={draggable}
			eventHandlers={{
				dragend: onMarkerDragEnd,
				click: onMarkerClick
			}}
		>
			{children}
		</Marker>
	);
}
